import { SvgIcon, SvgIconProps } from '../../../icons/SvgIcon';

export const LocationPinIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.75 8C4.75 5.10051 7.10051 2.75 10 2.75C12.8995 2.75 15.25 5.10051 15.25 8C15.25 9.56664 14.3988 11.3695 13.2662 13.0447C12.1506 14.6947 10.8421 16.1055 10.0902 16.8651C10.0521 16.9036 10.0116 16.9169 9.97708 16.9177C9.94293 16.9184 9.90412 16.9071 9.86658 16.8718C9.11158 16.1621 7.8159 14.8444 6.71404 13.2317C5.60205 11.6043 4.75 9.76673 4.75 8ZM10 1.25C6.27208 1.25 3.25 4.27208 3.25 8C3.25 10.2133 4.29886 12.3558 5.47554 14.078C6.66235 15.8149 8.04311 17.2164 8.83915 17.9647C9.50321 18.589 10.521 18.5622 11.1564 17.9203C11.9401 17.1285 13.3199 15.6432 14.5088 13.8849C15.6806 12.1517 16.75 10.0339 16.75 8C16.75 4.27208 13.7279 1.25 10 1.25ZM10 10C11.1046 10 12 9.10457 12 8C12 6.89543 11.1046 6 10 6C8.89543 6 8 6.89543 8 8C8 9.10457 8.89543 10 10 10Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
